// extracted by mini-css-extract-plugin
export default {"card":"v5-z"};